import { PresenceSeriesParams } from '@hakimo-ui/hakimo/types';

export function seriesQueryString(params: PresenceSeriesParams): string {
  const search = new URLSearchParams();
  if (params.from) search.set('from', params.from);
  if (params.to) search.set('to', params.to);
  if (params.bucket) search.set('bucket', params.bucket);
  const text = search.toString();
  return text ? `?${text}` : '';
}
